/* (ignored) */


//////////////////
// WEBPACK FOOTER
// jsdom (ignored)
// module id = 4
// module chunks = 0